import { Map } from 'immutable';
import { useReframe } from 'nike-re-framejs';

import { getPopup } from './popupRegistrar';

function PopupPortal() {
    const derefSub = useReframe();
    const popup = derefSub(['ui.popup/ng']) || Map();
    const Popup = getPopup(popup.get('name'));
    return Popup ? Popup(popup) : null;
}

export default PopupPortal;
